export * from "./resource.type";
export { default as ResourceApi } from "./resource.api";
